<div class="d-flex justify-content-between mb-4" *ngIf="memberDetails">
  <div class="card-id text-left mb-2">
    <div class="fw-bold card-name text-uppercase" *ngIf="memberDetails$ | async as memberDetails">
      {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
    </div>
    <div class="card-desc">
      <div class="text-start">{{ 'member.card.code' | translate }} {{ memberCard.MemberId }}</div>
    </div>
  </div>
</div>
<div class="d-flex flex-column justify-content-between member-details-section">
  <div class="d-flex justify-content-between gap-3 mb-3">
    <div class="w-100 glass-bg gloss-white card-account-no text-left" *ngIf="pointsBalance$">
      <div class="me-2">
        <span class="icon material-symbols-outlined">loyalty</span>
      </div>
      <div class="d-flex flex-column">
        <label class="font-size-14">{{ pointsBalance$ | async | number }}</label>
        <div class="font-size-12 mb-0">{{ 'member.card.points.balance' | translate }}</div>
      </div>
    </div>
    <div class="w-100 glass-bg gloss-white card-id text-left" *ngIf="combinedCard$">
      <div class="me-2">
        <span class="icon material-symbols-outlined">money_bag</span>
      </div>
      <div class="d-flex flex-column">
        <label class="font-size-14">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
        <div class="font-size-12 mb-0">{{ 'member.card.ecash.balance' | translate }}</div>
      </div>
    </div>
  </div>
  <!--eCash Button -->
  <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.nav.ecash'">
    <div class="ecash-button-account">
      <fgb-ecash-button [isMemberCard]="true"></fgb-ecash-button>
    </div>
  </ng-container>
</div>
